import { render, staticRenderFns } from "./_wbetnew.vue?vue&type=template&id=5c2fe238&lang=pug&"
import script from "./_wbetnew.vue?vue&type=script&lang=js&"
export * from "./_wbetnew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports